<div class="policy-frame">

    <div class="privacy-policy" id="privacyPolicy">
        <div class="close">
            <button (click)="close()">
                <img src="assets/icons/x-mark-48.png" alt="close">
            </button>
        </div>
        
        <div class="text" [innerHTML]="privacyPolicy">
            
        </div>
        
    </div>
</div>